import { Grid } from "@mui/material";
import { useState } from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { CONSULTAR_DELEGACION_PACIENTE } from "../../../../data/graphQL/queries/SoporteHC/consultas";
import { useQueryHandler } from "../../hooks/useQueryHandler";

export default function ConsultarDelegacionPacienteForm() {
    const inputFields = [
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC del paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
    ];

    const [result, setResult] = useState('');

    const { values, handleChange, handleSubmit, loading } =
        useQueryHandler({
            initialValues: {
                idPaciente: '',
            },
            query: CONSULTAR_DELEGACION_PACIENTE,
            onSuccess: (data) => {
                const { idDelegacionNavigation, nombre, apellido } = data?.pacienteSoporteHC || {};
                setResult(<span>Delegación (del paciente {nombre} {apellido}): <strong>{idDelegacionNavigation?.descripcion}</strong></span>);
            },
            handleChangeCallback: () => {
                setResult('');
            }
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
                {result && <Grid size={12}>{result}</Grid>}
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
